// extracted by mini-css-extract-plugin
export default {"root":"HistoryTable_root__G4VA+","header-wrapper":"HistoryTable_header-wrapper__fmbbX","datepicker-wrapper":"HistoryTable_datepicker-wrapper__PYNv-"};